<template>
  <div class="vehicle-animation">
    <!-- bus faces right (whole svg is css-mirrored), so the exhaust trails left -->
    <div class="exhaust-container">
      <div class="exhaust-puff puff-1"></div>
      <div class="exhaust-puff puff-2"></div>
      <div class="exhaust-puff puff-3"></div>
    </div>
    <div class="stapler-icon">
      <svg viewBox="4 3 56 55" width="29" height="28">
        <!-- geometry mirrors the fa_avatar.vue stapler variant (keep in sync) -->
        <g class="sb-bus">
          <!-- wheels get spokes so the spin reads at this size -->
          <g class="sb-wheel">
            <circle cx="18" cy="50.5" r="6.5" fill="#263238"/>
            <path d="M13.8 50.5 H22.2 M18 46.3 V54.7" stroke="#90a4ae" stroke-width="1.3"/>
            <circle cx="18" cy="50.5" r="2" fill="#cfd8dc"/>
          </g>
          <g class="sb-wheel">
            <circle cx="46" cy="50.5" r="6.5" fill="#263238"/>
            <path d="M41.8 50.5 H50.2 M46 46.3 V54.7" stroke="#90a4ae" stroke-width="1.3"/>
            <circle cx="46" cy="50.5" r="2" fill="#cfd8dc"/>
          </g>
          <rect x="9.5" y="32" width="43" height="4" rx="1.6" fill="#cfd8dc"/>
          <rect x="8" y="34" width="48" height="14.5" rx="3" fill="#e02b2b"/>
          <ellipse cx="39" cy="41" rx="8.5" ry="3.4" fill="#fff"/>
          <!-- counter-flipped in place so the badge survives the svg mirror -->
          <text x="39" y="42.2" transform="scale(-1 1) translate(-78 0)" text-anchor="middle" font-size="3" font-weight="700" letter-spacing="0.2" fill="#c62828" font-family="'Helvetica Neue', Arial, sans-serif">INITEK</text>
          <circle cx="10.3" cy="38.5" r="1.7" fill="#ffd54f"/>
          <rect x="7" y="46.5" width="50" height="4" rx="2" fill="#b71c1c"/>
          <!-- upper deck chews while it thinks -->
          <g class="sb-jaw">
            <rect x="8" y="15" width="48" height="18" rx="6" fill="#e02b2b"/>
            <rect x="11" y="16.5" width="13" height="2.2" rx="1.1" fill="#fff" opacity="0.35"/>
            <rect x="18.5" y="19" width="8.5" height="8.5" rx="2" fill="#28354f"/>
            <rect x="29.5" y="19" width="8.5" height="8.5" rx="2" fill="#28354f"/>
            <rect x="40.5" y="19" width="8.5" height="8.5" rx="2" fill="#28354f"/>
            <g class="sb-eye">
              <circle cx="13.8" cy="10.5" r="5.2" fill="#fff" stroke="#263238" stroke-width="1.4"/>
              <circle cx="13.1" cy="11.3" r="2.1" fill="#1a1f2e"/>
              <circle cx="12.3" cy="9.7" r="0.7" fill="#fff"/>
            </g>
            <g class="sb-eye">
              <circle cx="24.8" cy="10.5" r="5.2" fill="#fff" stroke="#263238" stroke-width="1.4"/>
              <circle cx="24.1" cy="11.3" r="2.1" fill="#1a1f2e"/>
              <circle cx="23.3" cy="9.7" r="0.7" fill="#fff"/>
            </g>
            <path d="M19 10.2 L19.6 10.2" stroke="#263238" stroke-width="1.4" stroke-linecap="round"/>
            <path d="M10.5 27.5 Q13.5 30 17 28" fill="none" stroke="#7f1d1d" stroke-width="1.3" stroke-linecap="round"/>
            <path d="M13.8 33 L16.8 33 L15.3 35.2 Z" fill="#1f3a93"/>
            <path d="M15.3 35 L17.4 41 L15.3 43 L13.2 41 Z" fill="#27429e"/>
          </g>
          <!-- hinge cap covers the joint while the jaw swings -->
          <rect x="50.5" y="29.5" width="7" height="7.5" rx="2.2" fill="#9c1212"/>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StaplerBusAnimation'
}
</script>

<style scoped>
.vehicle-animation {
  display: flex;
  align-items: center;
}

/* the art faces left; mirror the whole canvas so the bus drives right.
   inner animations are authored in the unmirrored space (wheel spin reads
   clockwise on screen, jaw still lifts the face). */
.stapler-icon svg {
  display: block;
  overflow: visible;
  transform: scaleX(-1);
}

.sb-bus {
  animation: sb-bob 0.6s ease-in-out infinite;
}

.sb-wheel {
  transform-box: fill-box;
  transform-origin: 50% 50%;
  animation: sb-wheel-spin 0.9s linear infinite;
}

/* hinge sits at the rear (right) edge; positive rotation lifts the face */
.sb-jaw {
  transform-box: view-box;
  transform-origin: 52px 33px;
  animation: sb-jaw-nibble 1.8s ease-in-out infinite;
}

.sb-eye {
  transform-box: fill-box;
  transform-origin: 50% 75%;
  animation: sb-eye-blink 4.6s ease-in-out infinite;
}

.exhaust-container {
  position: relative;
  width: 0px;
  height: 28px;
  margin-left: 16px;
}

.exhaust-puff {
  position: absolute;
  width: 7px;
  height: 7px;
  background-color: #999;
  border-radius: 50%;
  opacity: 0;
  right: 0;
}

.puff-1 {
  bottom: 5px;
  animation: sb-puff-float 1.2s ease-out infinite;
}

.puff-2 {
  bottom: 10px;
  animation: sb-puff-float 1.2s ease-out infinite 0.4s;
}

.puff-3 {
  bottom: 15px;
  animation: sb-puff-float 1.2s ease-out infinite 0.8s;
}

@keyframes sb-bob {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-1.6px); }
}

@keyframes sb-wheel-spin {
  to { transform: rotate(-360deg); }
}

@keyframes sb-jaw-nibble {
  0%, 64%, 100% { transform: rotate(0deg); }
  72% { transform: rotate(2.6deg); }
  80% { transform: rotate(0.5deg); }
  88% { transform: rotate(2.2deg); }
}

@keyframes sb-eye-blink {
  0%, 94%, 100% { transform: scaleY(1); }
  96% { transform: scaleY(0.08); }
}

@keyframes sb-puff-float {
  0% {
    opacity: 0.7;
    transform: translateX(0) scale(0.5);
  }
  100% {
    opacity: 0;
    transform: translateX(-15px) scale(1.2);
  }
}

@media (prefers-reduced-motion: reduce) {
  .sb-bus,
  .sb-wheel,
  .sb-jaw,
  .sb-eye,
  .exhaust-puff {
    animation: none !important;
  }
}
</style>
